import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'brand-logo',
  props: {
    homePageUrl: null,
    imageUrl: null,
    altText: null
  },
  setup(__props: any) {

const props = __props as {
  homePageUrl?: string
  imageUrl?: string
  altText?: string
};



const homeUrlWithProtocol = computed(() => {
  if (/^https?:\/\//.test(props.homePageUrl)) {
    return props.homePageUrl;
  }

  return `//${props.homePageUrl}`;
});

return { __sfc: true,props, homeUrlWithProtocol }
}

})